module.exports = __webpack_public_path__ + "img/image_q_11.webp";